module.exports = __webpack_public_path__ + "static/media/event.906d73c0.png";